<template>
  <div class='MakeCardCheck'>
    <search-form size='medium' labelWidth='90px' :searchData="search.searchData" :searchForm="search.searchForm"
      :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:orderSn="{ item }">
        <span @click="handleClick(item)" style="cursor: pointer; color: #409EFF;">{{ item.orderSn }}</span>
      </template>
      <template v-slot:refundStatus="{ item }">
        <span @click="handleCheckClick(item)" style="cursor: pointer;">{{ statusMap[item.refundStatus] }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList" :pager="pager" />
      </template>
    </Table>
    <el-dialog title="" :visible.sync="dialogVisible" width="1000px">
      <div>
        <div style="display: flex; align-items: center;margin: 20px 0;">
          <div>合同编号：{{ info.contactSn }}</div>
          <div style="margin: 0 20px;">购买人姓名：{{ info.customerName }}</div>
          <div>购买日期：{{ info.updateDate }}</div>
        </div>
        <Table :TableParam="moduleTable" style="margin: 0; padding: 0">
          <template v-slot:issueMethod="{ item }">
            <span>{{ $label.getLabel($label.SendTypes, Number(item.issueMethod)) }}</span>
      </template>
        <template v-slot:Paging>
          <Paging @change="getModuleList" :pager="modulePager" />
        </template>
      </Table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { handleCofirm } from '@/utils'

const props = { label: 'name', value: 'id' }

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
  },
  data () {
    // 这里存放数据
    return {
      modulePager: {
        orderSn: '',
        id: '',
        page: 1,
        rows: 10,
        count: 0
      },
      moduleTable: {
        isHeader: false,
        data: [],
        column: [
          { prop: 'cardNo', label: '预付卡号' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'issueMethod', label: '发行方式', slot: true  },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'denomination', label: '面值(元)'},
        ]
      },
      info: {

      },
      dialogVisible: false,
      statusMap: {
        1: '待审核',
        2: '已通过',
        3: '已驳回',
        4: '已取消',
      },
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      asyncData: { // 接口请求回来的数据
        cardTypeList: []
      },
      search: { // 搜索
        searchData: {
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '购买人', prop: 'customerName', placeholder: '请输入批次号' },
          {
            type: 'Select', label: '审核状态：', prop: 'refundStatus', props, width: '180px', options: [
              { name: '待审核', id: 1 },
              { name: '已通过', id: 2 },
              { name: '已驳回', id: 3 },], change: row => '', placeholder: '请选择审核状态'
          },

        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      Table: { // 表格
        data: [],
        column: [
          { type: 'selection' },
          { prop: 'orderSn', label: '退卡订单号', slot: true },
          { prop: 'originalOrderSn', label: '售卡订单号' },
          { prop: 'originalContactSn', label: '合同编号' },
          { prop: 'originalCustomerName', label: '购买人姓名' },
          { prop: 'originalOrderTime', label: '购买日期' },
          { prop: 'refundAmount', label: '合计金额' },
          { prop: 'createDate', label: '退卡提审日期' },
          { prop: 'refundStatus', label: '审核状态', slot: true },
          { prop: 'submitter', label: '提审人' }
        ]
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getModuleList () {
      const{ refundOrderId, page, rows } = this.modulePager
      const data = {
        refundOrderId,
        pageNum: page,
        pageSize: rows
      }
      return this.$http.refundDetailListApi(data).then(res => {
        this.moduleTable.data = (res?.data?.list || []).map((item) => ({
          ...item,
        }))
        this.modulePager.count = res?.data?.total || 0
      })
    },
    handleClick (row) {
      this.info = {}
      this.getDetail(row.originalOrderId)
      this.modulePager.refundOrderId = row.id
      this.getModuleList()
      this.dialogVisible = true
    },
    getDetail (id) {
      this.$http.detailSaleCardApi({ id }).then(res => {
        this.info = res.data || {}
    })
    },
    handleCheckClick (row) {
      if (row.refundStatus == 1) return
      let innerHtml =
        `<textarea rows="5" disabled style="width: 100%;border: none">${row.auditReason || ''}</textarea>`
      this.$alert(innerHtml, '理由', {
        dangerouslyUseHTMLString: true,
      });
    },
    searchHandleForm () {
      this.getItemList()
    },
    searchResetForm () {
      this.search.searchData = {  }
    },

    getItemList () { // 获取列表
      const { pager, search } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData,
      }
      this.$http.refundListApi(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = (res.data.list || [])
          }
        })
    },

    // 初始化
    init () {
      this.getItemList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
  .el-checkbox {
    width: 25%;
    margin-right: 0;

    &:nth-child(n + 4) {
      margin-top: 20px;
    }
  }
}
</style>
